import React from 'react';
import { Title } from 'react-admin';

export const HelpView = () => (
  <>
    <Title title="Help View Title" defaultTitle="Help View Title" />
    <p>Content TBD</p>
  </>
);
